import { useContext } from "react";
import { AuthContext } from "./AuthContext";
import Content from "../components/Content";
import Login from "../components/authentication/Login";

function RoutesSwitcher() {
  const { isAuthenticated, login, logout } = useContext(AuthContext);
  return isAuthenticated ? <Content onLogout={logout} /> : <Login onLogin={login} />;
}

export default RoutesSwitcher;
